import axios from "axios";
import { TradingBrokers } from "../enums/tradingEnums";

export const login = (data, setError, setLoading, navigate) => {
  setLoading(true);
  const [username, domain] = data.email.split("@");
  if (!domain) {
    setLoading(false);
    setError("Email address is invalid");
    return;
  }
  axios
    .post(`${process.env.REACT_APP_BASE_URL}/user/auth`, {
      ...data,
      username: data.email.toLowerCase(),
    })
    //sessionStorage.clear();
    .then((res) => {
      setLoading(false);
      const { userData, token } = res?.data?.data;
      localStorage.setItem("jwt", token);
      localStorage.session = JSON.stringify(userData);
      if (userData.applications?.length > 0) {
        navigate("/dashboard");
      } else {
        navigate("/onboarding/your-profile");
      }
    })
    .catch((error) => {
      setLoading(false);
      setError(error.response.data.message);
      //setError("Incorrect data");
    });

  //TODO check password error
};

export const validateOnboarding = (userData, navigate) => {
  const { brokerAccounts, applications = [] } = userData;
  const tradierAccount = brokerAccounts?.find(
    (ba) => ba.provider === TradingBrokers.TRADIER
  );
  const applicationsNo = applications.length;

  if (userData.role !== "customer") {
    navigate("/dashboard");
  } else {
    if (tradierAccount || applicationsNo > 0) {
      navigate("/dashboard");
    } else {
      navigate("/onboarding/your-profile");
    }
  }
};
